// React hooks for client components - re-exported from @apollo/client
// Note: Files that use these hooks should have "use client" directive
export { useMutation, useQuery } from "@apollo/client/react"

// Client-side exports
export { gql, makeClient } from "./client"

// Import for internal use
import { getBrowserClient } from "./client"
import { getServerClient } from "./serverClient"

/**
 * Get the Apollo client for data fetching.
 * Automatically routes to the correct client based on environment:
 * - In the browser: Uses HttpLink to make requests to the /fql endpoint
 * - On the server (RSC): Uses SchemaLink to execute queries directly against the schema
 */
export function getGqlClient() {
  if (typeof window !== "undefined") {
    return getBrowserClient()
  }
  return getServerClient()
}

/**
 * Alias for getGqlClient to match new API naming
 */
export function getClient() {
  return getGqlClient()
}
